const name = 'Qui'
const sub = 'Fullstack developer!'
const detail = `My name is Nguyen Phu Qui, i'm a senior at Ton Duc Thang University. 
    I have a passion for technology and learn it from an early age. 
    I joined a small team and had a few projects with my team when I was in high school, 
    i also developed and managed a miniature social networking project to connect people but it is closed. 
    In the future, i want to find a good job and apply existing knowledge, improve, accumulate more experience to improve my work.`

export { name, sub, detail }